export const loaderParams = {
    speed: 2,
    backgroundColor: '#f3f3f3',
    foregroundColor: '#ecebeb',
    title: 'Chargement...'
}